
import './login.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import user from '../../service/user';
import routing from './login.routes';
import LoginController from './login.controller';

export default angular.module('module.login', [
		uirouter,
		user
	])
	.config(routing)
	.controller('LoginController', LoginController)
	.name;



// WEBPACK FOOTER //
// ./src/page/login/index.js